import { ref } from 'vue';

export function useDocumentRevision(props: {
  hasRevision: string;
  modelValue: string;
}) {
  const hasRevision = ref(props.hasRevision);
  const externalRevision = ref(props.modelValue);

  return {
    hasRevision,
    externalRevision,
  };
}
